<h5 class="cmxa-products-list__title">{{blockTitle}}</h5>
<i *ngIf="subtitle"  class="cmxa-products-list__subtitle text-tertiary">{{subtitle}}</i>
<div  *ngIf="!!products">
  <ul class="cmxa-products-list" *ngIf="products.length; else emptyMessageText">
    <li *ngFor="let product of products; let index=index" class="cmxa-products-list__item">

      <ng-container *ngIf="isClientLink">
        <ng-container *ngIf="product.hasPublishedVersion; else disabledLink">
          <a [id]="'cmxa-recent-isPublished-' + index"
             [href]="ENV.cmxClientUrl + '?smartNumber=' + product.originalProductSmartNumber"
             adapt-button
             btn-type="tertiary"
             target="_blank"
             adaptTooltip="View published version"
             class="btn btn-link mr-2 cmx-view-published-btn">
            <span class="d-icon-arrow_right_eye"></span>
          </a>
        </ng-container>
        <ng-template #disabledLink>
          <button [id]="'cmxa-recent-isPublished-' + index"
                  adapt-button
                  btn-type="tertiary"
                  adaptTooltip="No published version available on the CMX Client"
                  class="btn btn-link disabled mr-2 cmx-view-published-btn">
            <span class="d-icon-arrow_right_eye"></span>
          </button>
        </ng-template>
      </ng-container>

      <a [attr.id]="linkId + index" [routerLink]="'product/' + product.smartNumber" class="cmxa-products-list__item-name">
        <span [className]="'badge ' + badgeClasses[product.publishingStatus]">{{product.publishingStatus}}</span>
        <span>{{product.name + ' ' + product.version + ' ' + (product?.servicePackName || '')}}</span>
      </a>
    </li>
  </ul>

  <ng-template #emptyMessageText>
    <p>{{ emptyMessage }}</p>
  </ng-template>
</div>
